<template>
    <v-table
        class="comparison-groups-table mt-2"
    >
        <thead>
            <tr>
                <th></th>
                <th
                    v-for="(head, index) in modelValue.comparisonMatrix.headers"
                    :key="`comp-group-${modelValue.uid}-head-${head.uid}`"
                    class="text-uppercase"
                    :class="{
                        't-border-header': index === currentProductIdx
                    }"
                >
                    <NuxtLink
                        :to="`/${head.path}`"
                    >
                        {{ head.name }}
                    </NuxtLink>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr
                v-for="row in modelValue.comparisonMatrix.rows"
                :key="`comp-group-${modelValue.uid}-row-${row.attribute.uid}`"
            >
                <th>{{ row.attribute.name }}</th>
                <td
                    v-for="(cell, index) in row.cells"
                    :key="`comp-group-${modelValue.uid}-cell-${cell.productUid}`"
                    :class="{
                        't-border-cell': index === currentProductIdx
                    }"
                >
                    <ComparisonGroupsCellValues
                        :model-value="cell.values"
                    ></ComparisonGroupsCellValues>
                </td>
            </tr>
        </tbody>
    </v-table>
</template>

<script lang="ts" setup>
    import type {
        ProductComparisonGroup
    } from '~/types';
    import ComparisonGroupsCellValues from '~/components/products/product/comparison-groups/ComparisonGroupsCellValues/ComparisonGroupsCellValues.vue';

    const props = defineProps<{
        modelValue: ProductComparisonGroup;
        productUid: string;
    }>();

    const currentProductIdx = computed<number>(() => props.modelValue.comparisonMatrix.headers.findIndex((header) => header.uid === props.productUid));
</script>

<style lang="scss">
.comparison-groups-table {

    td, th {
        min-width: 10rem;
    }

    thead {
        th {
            a {
                text-align: center;
                display: block;
            }
        }
    }

    --table-border-color: rgba(var(--v-border-color), var(--v-high-emphasis-opacity));

    .t-border-header,
    .t-border-cell {
        border-inline-start-width: 2px;
        border-inline-start-style: solid;
        border-inline-start-color: var(--table-border-color);
        border-inline-end-width: 2px;
        border-inline-end-style: solid;
        border-inline-end-color: var(--table-border-color);
    }
    .t-border-header {
        border-top-width: 2px;
        border-top-style: solid;
        border-top-color: var(--table-border-color);
        border-radius: 4px 4px 0 0;
    }

    tbody {
        td {
            text-align: center;
        }

        tr:last-child {
            .t-border-cell {
                border-bottom-width: 2px;
                border-bottom-style: solid;
                border-bottom-color: var(--table-border-color);
                border-radius: 0 0 4px 4px;
            }
        }
    }
}
</style>
